'use strict';

const closeMenuDesktop = () => {
    $('body').removeClass('cc-megamenu-open');
    $('.js-menu-overlay').addClass('d-none');
    $('.js-menu-close').addClass('d-none');
    $('.js-navbar-link').attr('aria-expanded', 'false');
    $('.js-header-banner').removeClass('cc-header-banner-hide');
    $('.js-header-banner').addClass('cc-header-banner-show');
    $('.cc-header').css('border-bottom', '');
};

/* const calcMaxHeight = () => {
    let headerHeight = $('.js-header').height();
    return `calc(100vh - ${headerHeight}px)`;
}; */

const openSection = (cgid, navbarHeight, megamenuHeight) => {
    $('.js-menu-overlay').addClass('d-none');
    $('.js-navbar-link').attr('aria-expanded', 'false');
    $('#menu-overlay-' + cgid).removeClass('d-none');

    $('body').addClass('cc-megamenu-open');
    $('.cc-navbar-list').css('content-visibility', 'visible');
    $('.js-menu-close').removeClass('d-none');
    if ($('#' + cgid).length) {
        $('#' + cgid).attr('aria-expanded', 'true');
    } else {
        $('.js-navbar-link[data-cs-override-id="' + cgid + '"]').attr('aria-expanded', 'true');
    }
    if ($('body').hasClass('cc-desktop') || $('body').hasClass('cc-tablet-landscape')) {
        $('.cc-navbar-list').css('min-height', navbarHeight + megamenuHeight);
    }
    $('.cc-header').css('border-bottom', 'none');
    $('.js-header-banner').addClass('cc-header-banner-hide');
    $('.js-header-banner').removeClass('cc-header-banner-show');
    $('body').trigger('analytics:openMenuSection');
};

const openSectionDelayed = (cgid, delay, navbarHeight, megamenuHeight, checkAfterDelay) => {
    setTimeout(() => {
        if (checkAfterDelay && !checkAfterDelay()) {
            return;
        }
        openSection(cgid, navbarHeight, megamenuHeight);
    }, delay);
};

const getAnalyticsTemplale = (menuType) => {
    var templateName = '';
    switch (menuType) {
    case 'catalog':
    case 'catalog-2':
        templateName = 'catalog-standard';
        break;
    case 'editorial':
        templateName = 'four-image';
        break;
    case 'editorialtextcol':
        templateName = 'three-image-advanced';
        break;
    case 'editorialtwoc':
        templateName = 'two-image';
        break;
    case 'editorialthreec':
        templateName = 'three-image';
        break;
    case 'editorialfivec':
        templateName = 'five-image';
        break;
    case 'lifestyle':
        templateName = 'catalog-image';
        break;
    case 'editorialtextcolfour': 
        templateName = 'four-image-advanced';
        break;
    }
    return templateName;
};

function getAnalyticsReference(element) {
    var navItem = element.parents('.js-navbar-item');
    var mainMenu = navItem.data('analyticsmainmenu');
    var type = navItem.data('analyticmenutype');
    var analyticsTemplate = getAnalyticsTemplale(type);
    return [mainMenu, analyticsTemplate];
}

module.exports = function () {
    var megamenuHeight = 0;
    var navbarHeight = 59;

    $(document).on('headerSticky:true', function() {
        navbarHeight = 35;
        megamenuHeight = $('.cc-menu-overlay:not(.d-none) .cc-menu-overlay-content').outerHeight();
        $('.cc-navbar-list').css('min-height', navbarHeight + megamenuHeight);
        // $('.cc-header').css('border-bottom', 'none');
    });
    $(document).on('headerSticky:false', function() {
        navbarHeight = 56;
        megamenuHeight = $('.cc-menu-overlay:not(.d-none) .cc-menu-overlay-content').outerHeight();
        $('.cc-navbar-list').css('min-height', navbarHeight + megamenuHeight);
        // $('.cc-header').css('border-bottom', 'none');
    });

    let isTouchMode = false;

    // Detect touchstart (user is using touchscreen)
    $(document).on('touchstart', function () {
        isTouchMode = true;
        if ($('.cc-desktop').length > 0) {
            $('.cc-desktop').addClass('cc-big-tablet');
        }
    });

    // Detect mousemove (user is using a real mouse)
    $(document).on('mousemove', function () {
        isTouchMode = false;
    });

    // click event to prevent default navigation on ipad
    $(document).on('click', '.cc-big-tablet .js-navbar-item .js-navbar-link', function (e) {
        e.preventDefault();
    });

    // Hover event (only runs if not in touch mode)
    $(document).on('mouseenter', '.cc-desktop .js-navbar-item, .cc-tablet-landscape .js-navbar-item', function (e) {
        if (isTouchMode) return; // Skip hover logic if user is in touch mode

        let isSearchOpen = $('.id-js-searchIcon').data('open');
        if (isSearchOpen) {
            return;
        }
        e.preventDefault();

        if ($('.cc-search-section').is(':visible')) {
            return false;
        }

        const cgid = $(this).data('cgid');
        var delayMenuHover = 300;

        if ($('.js-menu-close').hasClass('d-none')) {
            megamenuHeight = $('#menu-overlay-' + cgid + ' .cc-menu-overlay-content').outerHeight();
            openSectionDelayed(cgid, delayMenuHover, navbarHeight, megamenuHeight, () => {
                return $(this).is(':hover');
            });
        } else {
            megamenuHeight = $('#menu-overlay-' + cgid + ' .cc-menu-overlay-content').outerHeight();
            openSectionDelayed(cgid, delayMenuHover, navbarHeight, megamenuHeight, () => {
                if ($(this).is(':hover')) {
                    closeMenuDesktop();
                    return true;
                }
                return false;
            });
        }
    });

    // Touch event (always runs for touch devices)
    $(document).on('touchstart', '.cc-desktop .js-navbar-item, .cc-tablet-landscape .js-navbar-item', function (e) {
        isTouchMode = true; // Switch to touch mode
        let isSearchOpen = $('.id-js-searchIcon').data('open');
        if (isSearchOpen) {
            return;
        }
        e.preventDefault();

        if ($('.cc-search-section').is(':visible')) {
            return false;
        }

        const cgid = $(this).data('cgid');
        megamenuHeight = $('#menu-overlay-' + cgid + ' .cc-menu-overlay-content').outerHeight();

        openSectionDelayed(cgid, 300, navbarHeight, megamenuHeight, () => {
            return true; // Always open on touch
        });
    });

    $('.js-navbar-item').on('keydown', function(e) {
        const key = e.which;
        var arrowUp = $('.js-opencontent-header-menu-svg').data('arrowup');
        var arrowDown = $('.js-opencontent-header-menu-svg').data('arrowdown');
        const cgid = $(this).data('cgid');

        if (key === 40 || (key === 13 && e.target.classList.contains('js-opencontent-header-menu-svg') && $(this).find('#menu-overlay-' + cgid).hasClass('d-none'))) {
            $('.js-opencontent-header-menu-svg use').attr('xlink:href', arrowDown);
            $(this).find('.js-opencontent-header-menu-svg').css('opacity', 1);
            $(this).find('.js-opencontent-header-menu-svg use').attr('xlink:href', arrowUp);
            megamenuHeight = $('#menu-overlay-' + cgid + ' .cc-menu-overlay-content').outerHeight();
            openSection(cgid, navbarHeight, megamenuHeight);
        } else if (key === 38 || key === 27 || (key === 13 && e.target.classList.contains('js-opencontent-header-menu-svg') && !$(this).find('#menu-overlay-' + cgid).hasClass('d-none'))) {
            $(this).find('.js-opencontent-header-menu-svg').css('opacity', 1);
            $(this).find('.js-opencontent-header-menu-svg use').attr('xlink:href', arrowDown);
            $('.cc-navbar-list').css('min-height', '');
            $('.cc-header').css('border-bottom', '');
            closeMenuDesktop();
        } else if (key === 13) {
            $(this).find('a.js-navbar-link').length > 0 ? $(this).find('a.js-navbar-link')[0].click() : $(this).find('span.js-navbar-link')[0].click();
        }
    });

    $(document).on('keyup', '.js-navbar-item', function(e) {
        const key = e.which;
        if ((key === 9 || key === 16 || key === 13) && e.target.classList.contains('js-opencontent-header-menu-svg')) {
            $('body:not(.cc-megamenu-open) .cc-page-header-fixed .cc-header:not(.cc-header-sticky)').length > 0 ? $(this).find('.js-opencontent-header-menu-svg svg').css('fill', 'white') : $(this).find('.js-opencontent-header-menu-svg svg').css('fill', 'inherit');
            $(this).find('.js-opencontent-header-menu-svg').css('opacity', 1);
        } else {
            $('.js-opencontent-header-menu-svg').css('opacity', 0);
        }
    });

    $(document).on('click', function(e) {
        if (!e.target.classList.contains('js-opencontent-header-menu-svg')) {
            $('.js-opencontent-header-menu-svg').css('opacity', 0);
        }
    });

    $(document).on('touchstart', '.js-menu-close', function(e) {
        e.preventDefault();
        $('.cc-navbar-list').css('min-height', '');
        $('.js-opencontent-header-menu-svg').css('opacity', 0);
        closeMenuDesktop();
    });

    $(document).on('mouseleave', '.cc-desktop .js-navbar-list', function (e) {
        let isSearchOpen = $('.id-js-searchIcon').data('open');
        if (isSearchOpen) {
            return;
        }
        e.preventDefault();
        $('.cc-navbar-list').css('min-height', '');
        $('.cc-header').css('border-bottom', '');
        closeMenuDesktop();
    });

    // Mobile + Tablet
    $(document).on('click', '.cc-mobile .js-navbar-item .js-navbar-link, .cc-tablet-portrait .js-navbar-item .js-navbar-link', function (e) {
        e.preventDefault();

        if ($('.cc-search-section').is(':visible')) {
            return false;
        }

        var cgid = $(this).closest('.js-navbar-item').data('cgid');

        $('#menu-overlay-' + cgid).removeClass('cc-hide-mobile').removeClass('d-none').addClass('cc-show-mobile');
        $('.js-menu-container-' + cgid)
            .removeClass('cc-hide-mobile')
            .addClass('cc-show-mobile');
        $('.js-navbar-mobile-submenu').addClass('cc-hide-mobile');

        // accessibility: toggle aria-expanded attribute
        if ($('#' + cgid).length) {
            $('#' + cgid).attr('aria-expanded', 'true');
        } else {
            $('.js-navbar-link[data-cs-override-id="' + cgid + '"]').attr('aria-expanded', 'true');
        }
        $('body').trigger('analytics:openMenuSection');
        $(this).closest('.cc-navbar').addClass('cc-blocked');
        return false;
    });

    $(document).on('click', '.cc-mobile .js-menu-subcategory-name-container .js-menu-subcategory-name, .cc-tablet-portrait .js-menu-subcategory-name-container .js-menu-subcategory-name', function (e) {
        e.preventDefault();

        var cgid = $(this).closest('.js-menu-subcategory-name-container').data('cgid');

        if ($(this).closest('.js-menu-subcategory-name-container').hasClass('hasSub')) {
            $('.js-menu-subcategory-dis').each(function() {
                if (!$(this).hasClass('js-menu-subcategory-dis-' + cgid)) {
                    $(this).addClass('cc-hide-mobile');
                }
            });

            $('.js-menu-subcategory-link-container-' + cgid).addClass('cc-open');
            $('.js-menu-mobile-back-item').addClass('cc-hide-mobile');
            $('.js-menu-images-container').addClass('cc-hide-mobile');
            $(this).closest('.js-menu-subcategory-name-container').addClass('cc-hide-mobile');
            $(this).closest('.cc-navbar').addClass('cc-blocked');

            return false;
        } else {
            window.location.href = $(this).attr('href');
        }
    });
    // Mobile
    $(document).on('click', '.cc-mobile .js-menu-overlay-container .js-back-text, .cc-tablet-portrait .js-menu-overlay-container .js-back-text', function (e) {
        e.preventDefault();

        var cgid = $(this).data('cgid');

        $('#menu-overlay-' + cgid).addClass('cc-hide-mobile').removeClass('d-none');

        $('.js-menu-container-' + cgid).addClass('cc-hide-mobile');
        $('.js-navbar-mobile-submenu')
            .removeClass('cc-hide-mobile')
            .addClass('cc-show-mobile');

        // accessibility: toggle aria-expanded attribute
        if ($('#' + cgid).length) {
            $('#' + cgid).attr('aria-expanded', 'false');
        } else {
            $('.js-navbar-link[data-cs-override-id="' + cgid + '"]').attr('aria-expanded', 'false');
        }
        $(this).closest('.cc-navbar').removeClass('cc-blocked');
        return false;
    });

    $(document).on('click', '.cc-mobile .js-menu-subcategory-dis .js-back-text-subcategory, .cc-tablet-portrait .js-menu-subcategory-dis .js-back-text-subcategory', function (e) {
        e.preventDefault();

        var cgid = $(this).data('cgid');

        $('.js-menu-subcategory-dis')
            .removeClass('cc-hide-mobile')
            .addClass('cc-show-mobile');

        $('.js-menu-subcategory-link-container-' + cgid).removeClass('cc-open');
        $('.js-menu-mobile-back-item')
            .removeClass('cc-hide-mobile')
            .addClass('cc-show-mobile');
        $('.js-menu-images-container')
            .removeClass('cc-hide-mobile')
            .addClass('cc-show-mobile');
        $('.js-menu-subcategory-name-container')
            .removeClass('cc-hide-mobile')
            .addClass('cc-show-mobile');

        $(this).closest('.cc-navbar').removeClass('cc-blocked');
        return false;
    });

    $(document).on('click', '.cc-mobile .cc-header .cc-button-menu-mobile, .cc-tablet-portrait .cc-header .cc-button-menu-mobile', function (e) {
        $(this).toggleClass('cc-open');
        const mobileRef = $('.cc-mobile .cc-navbar');
        const tabletRef = $('.cc-tablet-portrait .cc-navbar');

        mobileRef.toggleClass('cc-open');
        tabletRef.toggleClass('cc-open');
        $('.cc-navbar-list').css('content-visibility', 'visible');
        // $('body').toggleClass('cc-blocked');
        e.preventDefault();
        if ($('.cc-mobile .cc-product-detail .cc-share-button-share').is(':visible') || $('.cc-tablet-portrait .cc-product-detail .cc-share-button-share').is(':visible')) {
            $('.cc-mobile-content-share').css('display', 'none');
            $('.cc-sticky-add-to-cart').css('display', 'unset');
            $('.cc-share-button-share').removeClass('cc-share-background-overlay');
            $('body').css('overflow', 'auto');
        }
        if ($(this).hasClass('cc-open')) {
            mobileRef.css('display', 'flex');
            tabletRef.css('display', 'flex');
            $('.helpButton, #embeddedMessagingConversationButton').css({
                display: 'none',
                visibility: 'hidden'
            });
            $('body').addClass('cc-blocked');
            $('body').addClass('cc-megamenu-open');
            $('.cc-button-menu-mobile').attr('aria-label', $('#js-closemenu-label').val());
        } else {
            mobileRef.css('display', 'none');
            tabletRef.css('display', 'none');
            $('.helpButton, #embeddedMessagingConversationButton').css({
                display: 'block',
                visibility: 'visible'
            });
            $('body').removeClass('cc-blocked');
            $('body').removeClass('cc-megamenu-open');
            $('.cc-button-menu-mobile').attr('aria-label', $('#js-openmenu-label').val());
        }
    });

    $(document).on('mousedown', '.js-navbar-analytics', function (e) {
        var navItem = $(this).parent('.js-navbar-item');
        var mainMenu = navItem.data('analyticsmainmenu');
        var type = navItem.data('analyticmenutype');
        var analyticsTemplate = getAnalyticsTemplale(type);
        var position = +navItem.data('analyticposition');
        position += 1;

        $('body').trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'Menu Click',
            eventAction: mainMenu,
            eventLabel: position, // a primo livello solo la position
            menu_hierarchy: mainMenu + '|' + position, // a primo livello non esistono secondo e terzo liv
            menu_template: analyticsTemplate
        });
    });

    $(document).on('mousedown', '.js-editorial-analytics', function (e) {
        var [mainMenu, analyticsTemplate] = getAnalyticsReference($(this));
        var position = +$(this).data('analyticposition');
        position += 1;
        var imageText = $(this).data('analyticsimagetitle');
        var eventLabel = position + '|' + imageText;

        $('body').trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'Menu Click',
            eventAction: mainMenu,
            eventLabel: eventLabel,
            menu_hierarchy: mainMenu + '|' + eventLabel,
            menu_template: analyticsTemplate
        });
    });

    $(document).on('mousedown', '.js-footer-analytics', function (e) {
        var [mainMenu, analyticsTemplate] = getAnalyticsReference($(this));
        var position = 'footer';

        $('body').trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'Menu Click',
            eventAction: mainMenu,
            eventLabel: position,
            menu_hierarchy: mainMenu + '|' + position,
            menu_template: analyticsTemplate
        });
    });

    $(document).on('mousedown', '.js-main-analytics-second', function (e) {
        var [mainMenu, analyticsTemplate] = getAnalyticsReference($(this));
        var position = $(this).data('analyticposition');
        var menuItem = $(this).data('analyticscgid');
        var eventLabel = position + '|' + menuItem;

        $('body').trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'Menu Click',
            eventAction: mainMenu,
            eventLabel: eventLabel,
            menu_hierarchy: mainMenu + '|' + eventLabel,
            menu_template: analyticsTemplate
        });
    });

    $(document).on('mousedown', '.js-main-analytics-third', function (e) {
        var [mainMenu, analyticsTemplate] = getAnalyticsReference($(this));
        var position = 'main';
        var secondLevelMenu = $(this).data('analyticssecondcgid');
        var thirdLevelMenu = $(this).data('analyticscgid');
        var eventLabel = position + '|' + secondLevelMenu + '|' + thirdLevelMenu;
        $('body').trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'Menu Click',
            eventAction: mainMenu,
            eventLabel: eventLabel,
            menu_hierarchy: mainMenu + '|' + eventLabel,
            menu_template: analyticsTemplate
        });
    });
};
